var Bavaria = "Bavária";
var Berlin = "Berlim";
var Brandenburg = "Brandemburgo";
var Bremen = "Brémen";
var Hamburg = "Hamburgo";
var Hesse = "Hesse";
var Saarland = "Sarre";
var Saxony = "Saxônia";
var Thuringia = "Turíngia";
var DEStates = {
	"Baden-Wuerttemberg": "Baden-Wuerttemberg",
	Bavaria: Bavaria,
	Berlin: Berlin,
	Brandenburg: Brandenburg,
	Bremen: Bremen,
	Hamburg: Hamburg,
	Hesse: Hesse,
	"Mecklenburg-Vorpommern": "Meclemburgo-Pomerânia Ocidental",
	"Lower Saxony": "Baixa Saxônia",
	"North Rhine-Westphalia": "Renânia do Norte-Vestfália",
	"Rhineland-Palatinate": "Renânia-Palatinado",
	Saarland: Saarland,
	Saxony: Saxony,
	"Saxony-Anhalt": "Saxônia-Anhalt",
	"Schleswig-Holstein": "Schleswig-Holstein",
	Thuringia: Thuringia
};

export { Bavaria, Berlin, Brandenburg, Bremen, Hamburg, Hesse, Saarland, Saxony, Thuringia, DEStates as default };
